module.exports = __webpack_public_path__ + "img/1.4b468102.png";